document.addEventListener('DOMContentLoaded', function () {
  const stickyBar = document.querySelector('#sticky-buy-bar');
  if (!stickyBar) return;

  // Function to toggle sticky bar
  const toggleStickyBar = () => {
    if (document.body.classList.contains('modal-show')) {
      stickyBar.style.display = 'none';
    } else {
      stickyBar.style.display = 'block';
    }
  };

  // Initial check
  toggleStickyBar();

  // Observe changes on body class
  const observer = new MutationObserver(toggleStickyBar);
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });
});



// for header hide when sticky bar appears
window.addEventListener('scroll', function() {
  var bar = document.getElementById('sticky-buy-bar');
  var header = document.querySelector('.header'); // select your header element

  if (window.scrollY > 150) {
    bar.style.transform = 'translateY(0)'; // show sticky bar
    if (header) {
      header.style.display = 'none'; // hide header
    }
  } else {
    bar.style.transform = 'translateY(-100%)'; // hide sticky bar
    if (header) {
      header.style.display = ''; // show header
    }
  }
});